import { Button } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import BusinessIcon from "@material-ui/icons/Business";
import ContactsIcon from "@material-ui/icons/Contacts";
import HistoryIcon from "@material-ui/icons/History";

function ListItem({ text, icon, direction }) {
  return (
    <div
      style={{
        margin: "auto",
        direction: direction,
        width: "230px",
        marginTop: 20,
        marginBottom: 20,
      }}
    >
      <div
        className={"m-auto p-0 bold ".concat(
          direction == "ltr" ? "text-left" : "text-right"
        )}
        style={{ whiteSpace: "nowrap" }}
      >
        <span className={direction == "ltr" ? "mr-3" : "ml-3"}>{icon}</span>{" "}
        {text}
      </div>
    </div>
  );
}
function SignUp(props) {
  if (props.auth.user || !props.settings.enable_social_auth) return <></>;
  const { language } = props;
  return (
    <div style={{ marginTop: 5 }}>
      <div className="mb-4">
        <ListItem
          icon={<BusinessIcon />}
          text={
            language == "english"
              ? "Save your addresses"
              : "احفظ عناوين التوصيل"
          }
          direction={language == "english" ? "ltr" : "rtl"}
        />
        <ListItem
          icon={<ContactsIcon />}
          text={
            language == "english"
              ? "Save your contact information"
              : "احفظ معلومات التواصل"
          }
          direction={language == "english" ? "ltr" : "rtl"}
        />
        <ListItem
          icon={<HistoryIcon />}
          text={
            language == "english" ? "One-tap re-ordering" : "اعادة الطلب السريع"
          }
          direction={language == "english" ? "ltr" : "rtl"}
        />
      </div>
      {!props.hideSignUpButton && (
        <div className="text-center">
          <Button
            variant="contained"
            color="primary"
            style={{ width: 250, height: 50, maxWidth: "80%" }}
            disableElevation
            onClick={() => {
              props.history.push("/profile");
              if (props.signUpExtraAction) props.signUpExtraAction();
            }}
            className="my-3"
          >
            <span className="bold">
              {language == "english" ? "Sign up" : "التسجيل السريع"}
            </span>
          </Button>

          {!!props.onContinueAsGuest && (
            <p
              className="mt-4 bold"
              style={{
                borderBottom: "2px solid #0099cc",
                width: language == "english" ? 142 : 100,
                margin: "auto",
                cursor: "pointer",
                borderColor: props.themeColor,
              }}
              onClick={() => props.onContinueAsGuest()}
            >
              {language == "english"
                ? "Or continue as Guest"
                : "أو المتابعة كزائر"}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    auth: state.auth,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

export default withRouter(connect(mapStateToProps)(SignUp));
